﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getWebPages, getWebPage, saveWebPage } from "@/api/Maintainers/web";

const key = "web_pages";

export function useWebPages() {
	return useQuery([key], () => getWebPages());
}

export function useWebPage(selected) {
	return useQuery([key, selected], () => selected && getWebPage({ selected }));
}

export function useMutationWebPage() {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveWebPage, {
		onSuccess: (response) => {
			const list = _.omit(response, "detail");
			const web_page = _.omit(response, "list");

			queryClient.setQueryData([key, String(web_page.detail.id)], web_page);
			queryClient.setQueryData([key], list);

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/paginas_web");
		},
	});
}
